import React from 'react'
import Route from '../../../../../Components/Router/Route'
import { Switch, withRouter } from 'react-router-dom'
import RecordedHome from './components/home'
import Lesson from './components/lesson'
import ReviewSubmissions from './components/review-submissions'

const Recorded = ({ match: { path } }) => {
  return (
    <Switch>
      <Route
        path={`${path}/chapter/:chapterId/lesson/:lessonId`}
        render={() => <Lesson />}
        isPrivate
      />
      <Route
        path={`${path}/review-submissions/:submissionId?`}
        render={() => <ReviewSubmissions />}
        isPrivate
      />
      <Route path={path} render={() => <RecordedHome />} />
    </Switch>
  )
}

export default withRouter(Recorded)
